import React from 'react';

import { useTranslation } from 'react-i18next';
import OperationsStateIcon, { type OperationsStateIconStates } from '../OperationStateIcon';
import Tooltip from '../Tooltip';
import {
  Count,
  Header,
  Label,
  LabelWrapper,
  Progress,
  Step,
  SubLabel,
  Title,
  Wrapper,
} from './wrapper';

interface ProgressCircleProps {
  label: string;
  subLabel?: string;
  steps?: number;
  completedSteps?: number;
  state?: OperationsStateIconStates;
  alert?: React.ReactNode;
}

const getStateTooltip = (state: OperationsStateIconStates) => {
  const { t } = useTranslation(['other', 'validation']);

  switch (state) {
    case 'completed':
      return t('processState.completed', { ns: 'other' });
    case 'inProgress':
      return t('processState.inProgress', { ns: 'other' });
    case 'notStarted':
      return t('processState.notStarted', { ns: 'other' });
    case 'problem':
      return t('processState.problem', { ns: 'other' });
    default:
      return t('unknown', { ns: 'validation' });
  }
};

const ProgressSteps = ({
  label,
  subLabel,
  steps = 0,
  completedSteps = 0,
  state,
  alert,
}: ProgressCircleProps) => (
  <Wrapper $state={state}>
    <Header>
      <Title>
        {state && (
          <Tooltip tooltip={getStateTooltip(state)}>
            <OperationsStateIcon state={state} />
          </Tooltip>
        )}
        <LabelWrapper>
          <Label>{label}</Label>
          {subLabel && <SubLabel>{subLabel}</SubLabel>}
        </LabelWrapper>
      </Title>
      <Count>
        {completedSteps}/{steps}
      </Count>
    </Header>
    {alert}
    <Progress aria-hidden="true">
      {Array.from({ length: steps }, (_, index) => (
        <Step key={`progress-${index}`} $filled={index < completedSteps} />
      ))}
    </Progress>
  </Wrapper>
);

export default ProgressSteps;
